module.exports = __webpack_public_path__ + "media/images/arrow_up-154b1994.svg";